
export class UsuarioLogadoConfig {

    nomeUsuario: string;
    mostraSelectMercados: boolean;

    constructor(nomeUsuario: string = "",
                mostraSelectMercados?: boolean) {
        this.nomeUsuario = nomeUsuario;
        this.mostraSelectMercados = mostraSelectMercados
    }

    

}
